import {Layout, Carousel, Image, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';

const {Text, Paragraph} = Typography;
const Content = Layout;
const SafetyTraining = () => {
  return (
    <Layout style={{margin: '5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className= 'Title3' style={{color: appColors['ColorX']}}>Training</Paragraph>
        <Text className='BaseText6'>In order to get personal knowledge on how to work correctly in the laboratory and all precautions we have to take into account when working with blood samples, polyacrylamide gels and nucleic acids, each member of the Wet Lab area had to take the course provided by Professor David Chavaro from Tecnológico de Monterrey Campus Ciudad de México. Also other people from our iGEM team participated in this training, so even though they aren’t part of the Wet Lab area, we delivered them a certificate as well.</Text>
        <Layout style={{background: 'inherit', width: 'fit-content', display: 'block'}}>
          <Content style={{float: 'left', background: 'inherit', marginTop: '6%'}}>
            <Text className='BaseText5'>
              <ul>
                <li>General safety precautions in lab</li>
                <li>Types of laboratory and safety equipment</li>
                <li>Biosecurity plan</li>
                <li>Personal protective equipment</li>
                <li>Handling blood samples</li>
                <li>Polyacrylamide gels</li>
                <li>Handling nucleic acids</li>
                <li>Right disposal of biological hazardous material</li>
              </ul>
            </Text>
          </Content>
          <Content style={{width: 'fit-content', display: 'block', marginLeft: '69vh', marginTop: '3%', background: 'transparent'}}>
            <Carousel autoplay effect='fade' dotPosition='right' style={{marginLeft: '50%', transform: 'translateX(-50%)', width: '60vh'}}>
              <div>
                <Image src='https://static.igem.wiki/teams/4464/wiki/wet-lab/34.png' preview={false}/>
              </div>
              <div>
                <Image src='https://static.igem.wiki/teams/4464/wiki/wet-lab/35.png' preview={false}/>
              </div>
              <div>
                <Image src='https://static.igem.wiki/teams/4464/wiki/wet-lab/36.png' preview={false}/>
              </div>
              <div>
                <Image src='https://static.igem.wiki/teams/4464/wiki/wet-lab/37.png' preview={false}/>
              </div>
            </Carousel>
          </Content>
        </Layout>
      </Content>
    </Layout>
  );
};

export default SafetyTraining;
